import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { resetToDefaultTheme, setDefaultTheme, setTheme } from '../../apis/themeSlice';
import { THEME_PRESETS } from '../../theme/themeConfig';
import ThemeSettingsStyle from './ThemeSettings.module.scss';

const FIELD_CONFIG = [
  { key: 'sidebarBg', label: 'Sidebar Background' },
  { key: 'sidebarBorder', label: 'Sidebar Border' },
  { key: 'sidebarItemBg', label: 'Sidebar Menu Item' },
  { key: 'sidebarItemHoverBg', label: 'Sidebar Menu Hover' },
  { key: 'sidebarActiveBg', label: 'Sidebar Active Item' },
  { key: 'sidebarText', label: 'Sidebar Text' },
  { key: 'sidebarActiveText', label: 'Sidebar Active Text' },
  { key: 'pageBg', label: 'Page Background' },
  { key: 'primary', label: 'Primary Theme' },
  { key: 'primaryDark', label: 'Primary Dark' },
  { key: 'heading', label: 'Heading Color' },
  { key: 'buttonText', label: 'Button Text' },
];

const isSameTheme = (leftTheme, rightTheme) => {
  if (!leftTheme || !rightTheme) return false;
  const keys = Object.keys(rightTheme);
  return keys.every((key) => leftTheme[key] === rightTheme[key]);
};

export default function ThemeSettings() {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.themeData);

  const onColorChange = (key, value) => {
    dispatch(setTheme({ [key]: value }));
  };

  const onSetCurrentAsDefault = () => {
    dispatch(setDefaultTheme(theme));
    toast.success('Current theme saved as default.');
  };

  const onLoadDefault = () => {
    dispatch(resetToDefaultTheme());
    toast.success('Default theme loaded.');
  };

  const onApplyPreset = (presetValues) => {
    dispatch(setTheme(presetValues));
    toast.success('Preset theme applied.');
  };

  return (
    <div className={ThemeSettingsStyle.themePage}>
      <Paper elevation={0} className={ThemeSettingsStyle.themeCard}>
        <Typography variant="h6" className={ThemeSettingsStyle.title}>
          Theme Settings
        </Typography>
       

        <Box className={ThemeSettingsStyle.section}>
          <Typography className={ThemeSettingsStyle.sectionTitle}>Quick Presets</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {THEME_PRESETS.map((preset) => (
              (() => {
                const isActivePreset = isSameTheme(theme, preset.values);
                return (
              <Button
                key={preset.id}
                size="small"
                variant={isActivePreset ? 'contained' : 'outlined'}
                onClick={() => onApplyPreset(preset.values)}
                className={isActivePreset ? 'dialogSubmitBtn' : ''}
              >
                {isActivePreset ? `${preset.name}` : preset.name}
              </Button>
                );
              })()
            ))}
          </Stack>
        </Box>

        <div className={ThemeSettingsStyle.grid}>
          {FIELD_CONFIG.map((field) => (
            <div key={field.key} className={ThemeSettingsStyle.colorField}>
              <label className={ThemeSettingsStyle.fieldLabel}>{field.label}</label>
              <TextField
                type="color"
                value={theme[field.key]}
                onChange={(event) => onColorChange(field.key, event.target.value)}
                fullWidth
                size="small"
              />
            </div>
          ))}
        </div>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.2} mt={2}>
          <Button variant="contained" className="dialogSubmitBtn" onClick={onSetCurrentAsDefault}>
            Set Current As Default
          </Button>
          <Button variant="outlined" onClick={onLoadDefault}>
            Load Default Theme
          </Button>
        </Stack>
      </Paper>
    </div>
  );
}
